<template>
  <div class="journal-history-container center-text">
    <div class="d-flex justify-end mr-2">
      <v-icon @click.stop="$emit('close')" class="mr-n2">
        close
      </v-icon>
    </div>
    <h2 class="pb-4">
      {{ $t('journal.recommendationHistory.title') }}
    </h2>
    <ScrollBar
      class="journal-history-results"
      @reachedYBreakpoint="update"
      :breakpoint="200"
      max-height="70vh"
    >
      <DocumentCardIterator
        :items="recommendations(journalHistory)"
      >
        <template v-slot:item="{ item }">
          <HorizontalCard
            :key="item.id"
            :document-data="item"
            :show-evaluation="false"
            :allow-adding-to-reflection="false"
          />
        </template>
      </DocumentCardIterator>
      <div class="d-flex justify-center pa-6">
        <v-progress-circular
          v-if="fetching"
          indeterminate
          :size="30"
          :width="4"
        />
      </div>
    </ScrollBar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ScrollBar from '@/shared/components/scrollbar/ScrollBar';
import DocumentCardIterator from '../../cards/DocumentCardIterator';
import HorizontalCard from '../../cards/documentCards/HorizontalCard';
import { types } from '../../../store/rootTypes';

export default {
  name: 'JournalHistory',
  components: {
    DocumentCardIterator,
    HorizontalCard,
    ScrollBar,
  },
  props: {
    journalId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  created() {
    this.update();
  },
  computed: {
    ...mapGetters({
      journalHistory: types.recommendationBasedJournals.getters.journalHistory,
    }),
  },
  methods: {
    ...mapActions({
      fetchJournalHistory: types.recommendationBasedJournals.actions.fetchJournalHistory,
    }),
    recommendations(journalHistory) {
      const history = journalHistory[this.journalId];

      if (history) {
        return history.documents;
      }
      return [];
    },
    async update() {
      if (this.fetching) return;

      this.fetching = true;
      await this.fetchJournalHistory(this.journalId);
      this.fetching = false;
    },
  },
};
</script>
<style scoped>
.journal-history-container {
  padding: 12px;
  background: white;
  border-radius: 8px;
}
.journal-history-results {
  background-color: #F6F5FA;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
}
.center-text {
  text-align: center;
}
</style>
